import { telemetry } from '../../api/client';
import { reduceMatrix } from '../mapping';
import type { StatPanelConfig } from '../types';
import { PanelEmpty, PanelError, PanelSkeleton } from './chrome';
import { usePanelQuery } from './usePanelQuery';

export interface StatPanelProps {
  panel: StatPanelConfig;   // options?.reduce defaults to 'last' (design §3)
  timeRange: string;
  refreshMs: number;
  unit?: string;            // from the metrics catalogue (passed by the page)
}

export function StatPanel({ panel, timeRange, refreshMs, unit }: StatPanelProps) {
  const { data, isLoading, isError, refetch } = usePanelQuery(
    ['telemetry', 'query', panel.metric, panel.serials],
    timeRange,
    refreshMs,
    (w) => telemetry.query({ metric: panel.metric, serials: panel.serials, ...w }),
  );

  if (isLoading) return <PanelSkeleton />;
  if (isError) return <PanelError onRetry={() => void refetch()} />;

  const value = reduceMatrix(data?.series ?? [], panel.options?.reduce ?? 'last');
  if (value === null) return <PanelEmpty />;

  return (
    <div className="h-full flex flex-col items-center justify-center">
      <span className="text-3xl font-semibold text-white">
        {value >= 100 ? value.toFixed(0) : value.toFixed(1)}
      </span>
      {unit && <span className="text-xs text-gray-500">{unit}</span>}
    </div>
  );
}
